const GOOGLE_ADS_ID = 'AW-18429248769';
const REGISTRATION_DESTINATION = `${GOOGLE_ADS_ID}/hj9kCNjeyPMcEIGK4NNE`;
const APP_ORIGIN = 'https://app.cinebudgetpro.com';
const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
let initialized = false;
const reportedRegistrations = new Set();

const publicPageContext = () => {
  const path = /^\/auth\/(signup|login)\/?$/.test(window.location.pathname)
    ? window.location.pathname
    : '/';
  let referrer = '';
  try {
    const url = new URL(document.referrer);
    if (['www.cinebudgetpro.com', 'cinebudgetpro.com'].includes(url.hostname)) {
      referrer = `${url.origin}${url.pathname}`;
    }
  } catch {
    // Direct visits have no referrer.
  }
  return {
    page_location: `${APP_ORIGIN}${path}`,
    page_referrer: referrer,
    page_title: 'CineBudget Pro',
  };
};

export const initializeGoogleAds = () => {
  if (window.location.hostname !== 'app.cinebudgetpro.com') return false;
  if (initialized) return true;

  try {
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function () {
        window.dataLayer.push(arguments);
      };
    window.gtag('js', new Date());
    window.gtag('config', GOOGLE_ADS_ID, {
      send_page_view: false,
      // The app contains private budgets and authentication URL parameters.
      // Send only this public entry route, never document URLs or user data.
      ...publicPageContext(),
      allow_ad_personalization_signals: false,
      allow_enhanced_conversions: false,
    });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
    document.head.appendChild(script);
    initialized = true;
    return true;
  } catch {
    // Advertising failures must never prevent account access.
    return false;
  }
};

export const trackCompletedRegistration = responseData => {
  const eventId = responseData?.registration_event_id;
  if (
    !responseData?.token ||
    typeof eventId !== 'string' ||
    !UUID_PATTERN.test(eventId) ||
    reportedRegistrations.has(eventId)
  )
    return false;

  try {
    if (!initializeGoogleAds()) return false;
    window.gtag('event', 'conversion', {
      send_to: REGISTRATION_DESTINATION,
      transaction_id: eventId,
      ...publicPageContext(),
    });
    reportedRegistrations.add(eventId);
    return true;
  } catch {
    return false;
  }
};
